import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export interface GetAdminUsersResponse {
  email: string;
  fullName: string;
  legacyId: number;
  uuid: string;
}

const getAdminUsers = async ({ email }: { email?: string }) => {
  const queryParams = paramsSerializer({ email });
  const url = `${import.meta.env.VITE_USERS_HOST}/v1/admin/users?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetAdminUsers = ({ email }: { email?: string }, options?: Record<string, boolean>) => {
  return useGenericQuery<GetAdminUsersResponse, RequestError>(
    [QUERY_KEYS.getAdminUsers, email],
    () => getAdminUsers({ email }),
    {
      enabled: options?.enabled,
    },
    options?.disableLoading
  );
};
